<template>
  <Dialogs :dialog="dialog" :handleClose="handleClose">
    <template #content>
      <div class="dialog_content">
        <el-form ref="form" :model="form" :rules="rules" label-width="200px" size="small" v-if="type == 0">
          <el-form-item id="time" label="发布日期" prop="year" class="inlinitem">
            <el-date-picker :disabled="dialog.title == '详情'" v-model="form.year" type="year"
              :picker-options="pickerOptions" value-format="yyyy" style="width: 200px" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="交通运输排放量" prop="transportation">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.transportation"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="工业排放量" prop="industrial">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.industrial"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="农业排放量" prop="agriculture">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.agriculture"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="其他行业排放量" prop="otherIndustries">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.otherIndustries" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" :rules="rules" label-width="200px" size="small" v-else-if="type == 1">
          <el-form-item id="time" label="发布日期" prop="year" class="inlinitem">
            <el-date-picker :disabled="dialog.title == '详情'" v-model="form.year" type="year" value-format="yyyy"
              :picker-options="pickerOptions" style="width: 200px" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="茶叶咖啡种植量" prop="teaCoffee">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.teaCoffee"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="沼气粪肥量" prop="biogasManure">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.biogasManure"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="人工林" prop="plantedForest">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.plantedForest"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="天然林" prop="naturalForest">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.naturalForest"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="水电" prop="hydropower">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.hydropower"
              placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" :rules="rules" label-width="200px" size="small" v-else-if="type == 2">
          <el-form-item id="time" label="发布日期" prop="year" class="inlinitem">
            <el-date-picker :disabled="dialog.title == '详情'" v-model="form.year" type="year" value-format="yyyy"
              :picker-options="pickerOptions" style="width: 200px" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="沼气粪肥量" prop="biogasManure">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.biogasManure"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="人工林" prop="plantedForest">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.plantedForest"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="水电" prop="hydropower">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.hydropower"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="天然林" prop="teaCoffee">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.teaCoffee"
              placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" :rules="rules" label-width="200px" size="small" v-else-if="type == 3">
          <el-form-item id="time" label="发布日期" prop="year" class="inlinitem">
            <el-date-picker :disabled="dialog.title == '详情'" v-model="form.year" value-format="yyyy" type="year"
              :picker-options="pickerOptions" style="width: 200px" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="大工业" prop="greatIndustry">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.greatIndustry"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="非普工业" prop="generalIndustrial">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.generalIndustrial" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="商业" prop="business">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.business"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="居民生活" prop="residentsLiving">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.residentsLiving" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="养殖业" prop="aquaculture">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.aquaculture"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="交通运输业" prop="transportationIndustry">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.transportationIndustry" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="非居民照明" prop="residentPhotograph">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.residentPhotograph" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="农业生产" prop="agriculturalProduction">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.agriculturalProduction" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="农业排灌" prop="agriculturalDrainage">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.agriculturalDrainage" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" :rules="rules" label-width="200px" size="small" v-else-if="type == 4">
          <el-form-item id="time" label="发布日期" prop="year" class="inlinitem">
            <el-date-picker :disabled="dialog.title == '详情'" v-model="form.year" type="year" value-format="yyyy"
              :picker-options="pickerOptions" style="width: 200px" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="工业生产" prop="industrialProduction">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.industrialProduction" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="农业生产" prop="agriculturalProduction">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.agriculturalProduction" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="交通运输" prop="transportation">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16" v-model="form.transportation"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="其他行业" prop="otherIndustries">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.otherIndustries" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" :rules="rules" label-width="265px" size="small" v-else-if="type == 5">
          <el-form-item id="time" label="发布日期" prop="year" class="inlinitem">
            <el-date-picker :disabled="dialog.title == '详情'" v-model="form.year" type="year" value-format="yyyy"
              :picker-options="pickerOptions" style="width: 200px" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="碳排放总量" prop="totalCarbonEmission">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.totalCarbonEmission" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="碳吸收总量（包括天然林）" prop="totalCarbonAbsorption">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.totalCarbonAbsorption" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="可供抵消的碳吸收总量" prop="offsetTotalCarbonAbsorption">
            <el-input :disabled="dialog.title == '详情'" style="width:405px;" maxlength="16"
              v-model="form.offsetTotalCarbonAbsorption" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <!-- 按钮 -->
    <template #btns v-if="isView">
      <el-button round @click="handleClose">取消</el-button>
      <el-button round type="primary" @click="submitForm">发布</el-button>
    </template>
  </Dialogs>
</template>
<script>
import { carbonEmissionSubmit, carbonUptakeSubmit, carbonEmissionReductionsSubmit, industryCarbonEmissionsSubmit, carbonEmissionsOverTimeSubmit, annualCarbonEmissionsSubmit } from "@/api/api";
import Dialogs from "@/components/dialogs/dialogs.vue"

export default {
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {
          size: 720,
          visible: false,
          title: "新增",
        }
      }
    },
    handleClose: {
      type: Function,
      default: () => { }
    },
    isView: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    },
    form: {
      type: Object,
      default: () => {
        return {
          year: '', // 年份
          transportation: '', // 交通运输排放量
          industrial: '', // 工业排放量
          agriculture: '', // 农业排放量
          otherIndustries: '', // 其他行业排放量
        }
      }
    },
  },
  data() {
    return {
      loading: false,
      close: function () { },
      // 校验
      rules: {
        year: [{ required: true, message: "选择日期" }],
        transportation: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        industrial: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        agriculture: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        otherIndustries: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],

        teaCoffee: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        biogasManure: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        plantedForest: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        naturalForest: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        hydropower: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],

        greatIndustry: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        generalIndustrial: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        business: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        residentsLiving: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        aquaculture: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        transportationIndustry: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        residentPhotograph: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        agriculturalProduction: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        agriculturalDrainage: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],

        industrialProduction: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],

        totalCarbonEmission: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        totalCarbonAbsorption: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],
        offsetTotalCarbonAbsorption: [{ required: false, }, { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入整数或小数点后两位' }],


      },

      pickerOptions: {
        disabledDate(date) {
          let zero = new Date().setHours(0, 0, 0, 0);
          if (date.getTime() > zero) {
            return true;
          }
          return false;
        },
      },
    }
  },
  methods: {
    // 提交
    async submitForm() {
      let bol = true;
      // 判断rowid是否存在  存在则是编辑  否则新增
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if (bol) {
        let funAdd = [carbonEmissionSubmit, carbonUptakeSubmit, carbonEmissionReductionsSubmit, industryCarbonEmissionsSubmit, carbonEmissionsOverTimeSubmit, annualCarbonEmissionsSubmit]
        const res = await funAdd[this.type](this.form)
        if (res.data.code == 200) {
          this.$message.success(this.dialog.title + '成功')
          this.$parent.getList()
          this.dialog.visible = false
        } else this.$message.error(res.data.message)
      }
    },
  },
  components: {
    Dialogs,
  },
  watch: {
    'dialog.visible': {
      handler(newV, oldV) {
        if (newV) {
          this.$nextTick(() => this.$refs.form.clearValidate())
        }
      },
      immediate: true

    }
  }
}
</script>
<style scoped>
::v-deep .inlinitem.el-form-item {
  display: inline-flex;
  justify-content: flex-start;
}

::v-deep .inlinitem.el-form-item .el-form-item__content {
  margin-left: 2px !important;
}

.h120 {
  height: 120px;
}

::v-deep .h120 .el-textarea__inner {
  height: 120px;
}
</style>